import { ResourceConfig } from '@repo/core/resources';
import { HttpClient } from '@repo/core/api';

const http = new HttpClient({ baseURL: ResourceConfig.clientPortalServerBase });

export const useClientPortalService = () => {
  const status = async (): Promise<boolean> => {
    if (!ResourceConfig.enableClientPortal) return false;
    try {
      await http.get(`version`);
      return true;
    } catch (err: any) {
      if (err.response && err.response.status >= 0) {
        return true;
      }
      console.warn('Client Portal API is down.');
      return false;
    }
  };

  return {
    status
  };
};
